<template>
  <div class="ai-warp">
    <div class="header-warp">
      <header class="layoutMaxWidth">
        <h2>刷卡、扫码一体化！</h2>
        <p>安卓智能食堂收银机</p>
        <p>全功能收银和管理利器</p>
        <img src="@/assets/img/card/card.png" alt />
      </header>
    </div>

    <main>
      <title>安卓智能收银机</title>
      <ul class="layoutMaxWidth">
        <li>
          <img src="@/assets/img/card/a1.png" alt />
          <h2>聚合收银</h2>
          <p>支持食堂卡刷卡支付，支持扫码、支付宝、微信等多种支付方式</p>
        </li>
        <li>
          <img src="@/assets/img/card/a2.png" alt />
          <h2>操作简便，提高收银速度</h2>
          <p>大屏触碰操作，预装皓范软件，支持菜单收银、金额收银以及多种收银模式</p>
        </li>
        <li>
          <img src="@/assets/img/card/a3.png" alt />
          <h2>数据实时同步</h2>
          <p>基于无线和云服务部署，实时统计当日数据，对于连锁型团餐企业，可即时了解多个网点的数据</p>
        </li>
      </ul>
    </main>
  </div>
</template>
<script>
export default {
  name: "card",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.ai-warp {
  .header-warp {
    background: url("~@/assets/img/ai/bg1@2x.png") center center no-repeat;
    height: 437px;
  }
  header {
    display: block;
    font-style: italic;
    position: relative;
    h2 {
      padding-top: 144px;
      font-size: 56px;
      padding-bottom: 31px;
    }
    p {
      letter-spacing: 4px;
      font-size: 20px /*px*/;
      font-weight: 700;
      line-height: 40px;
    }
    img {
      position: absolute;
      top: 213px;
      right: 0px;
      width: 395px;
    }
  }
  main {
    background: url("~@/assets/img/ai/bg@2x.png") center no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 600px;
    title {
      display: inline-block;
      width: 100%;
      font-size: 21px /*px*/;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: white;
      padding-top: 89px;
    }
    title::after,
    title::before {
      display: inline-block;
      content: "";
      width: 64px;
      height: 1px;
      background-color: #9c9fa1;
      vertical-align: middle;
      margin-right: 16px;
    }
    title::after {
      margin-right: 0px;
      margin-left: 16px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      margin-top: 61px;
      align-items: center;
      li {
        background-color: white;
        padding: 74px 34px 0;
        margin-right: 17px;
        margin-top: 16px;
        width: 32.5%;
        height: 314px;
        box-sizing: border-box;
        text-align: center;
        img {
          width: 54px;
        }
        h2 {
          font-size: 16px /*px*/;
          color: $primary-color;
          margin-top: 26px;
        }
        p {
          margin-top: 26px;
          font-size: 11px /*px*/;
          line-height: 1.8em;
          text-align: left;
        }
      }
      li:nth-child(3n) {
        margin-right: 0px;
      }
      li:first-child{
        h2{
          margin-top: 32px;
        }
      }
    }
  }
}
</style>